<template>
<div >
          <div id="UserInfo">
           
          <h2 class="m4u_text--text">{{profile.UserFirst}} {{profile.UserLast}} 
               <h4 class="m4u_text--text" v-if="emailChangeMsg">To complete your email change, open the email we just sent and confirm.</h4>
        </h2> 
      <div><v-img :src="profilesas" class="white--text align-end imageTag" max-width="3rem"></v-img></div>
          
<!-- START OF UPLOADING FILES -->
<!-- BEGINNING OF ADD MEDIA DIALOG -->

<v-row class="photoBtn" >
    <v-dialog
      v-model="idialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          class="mediaBtn"
        >
         <v-icon class="m4u_text--text">mdi-camera</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline m4u_text--text">Change Your Photo</span>
        </v-card-title>
        <v-card-text>
          <v-container>
    <v-row no-gutters justify="center" align="center">
      <v-col cols="6">
    <div class="large-12 medium-12 small-12 cell">

        <input type="file" id="file" ref="file" class="m4u_text--text" v-on:change="handleFileUpload()"/>

    </div>
      </v-col>
    </v-row>
    

    <v-alert v-if="message" border="left" color="blue-grey" dark>
      
    </v-alert>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="cancelFileUpload()"
          >
            Cancel
          </v-btn>

        </v-card-actions>
      </v-card>

    </v-dialog>

<!-- EDIT USER NAME/EMAIL DIALOG -->        
  <v-dialog
      v-model="edialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          @click="getUserInfo()"
        >
         <v-icon class="m4u_text--text">mdi-pencil-outline</v-icon>
        </v-btn>
      </template>
      <v-card>

        <v-card-text>
          <v-container>
            <v-form ref="eform">
             
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  label="First name*"
                  v-model = newUser.UserFirst
                  required
                  :rules="nameRules"
                  color="m4u_text"
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  label="Last name*"
                  v-model = newUser.UserLast
                  required
                  color="m4u_text"
                  :rules="nameRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Email*"
                  v-model = newUser.UserEmail
                  required
                  color="m4u_text"
                  :rules="emailRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Display Name*"
                  v-model="newUser.UserDisplayName"
                  hint="Enter how you want others to see your name"
                  persistent-hint
                  color="m4u_text"
                  required
                  :rules="displayNameRules"
                ></v-text-field>
              </v-col>

            </v-row>
            </v-form>
               <v-dialog
      v-model="pdialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          class="m4u_text--text"
          dark
          v-bind="attrs"
          v-on="on"

        >
          Change Password
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text--h5 m4u_text--text">Change Password</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div class="center--text"><h2 class="primary dark">{{passwordChangeMsg}}</h2></div>
            <v-row>
              <v-col cols="12">
  <v-text-field
  v-model="oldPassword"
  color="m4u_text"
  id="oldPassword"
  name="oldPassword"
  label="Old password" 
  :type="show1 ?'text': 
  'password'"
  :append-icon="show1 ?'mdi-eye':'mdi-eye-off'"   
  @click:append="show1=!show1">
</v-text-field>

              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
  <v-text-field
  v-model="password1"
  color="m4u_text"
  id="password1"
  name="password1"
  label="New password" 
  :type="show1 ?'text': 
  'password'"
  :append-icon="show1 ?'mdi-eye':'mdi-eye-off'"   
  @click:append="show2=!show2">
</v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
  <v-text-field
  color="m4u_text"
  v-model="password2"
  id="password2"
  name="password2"
  label="Retype new password" 
  :type="show1 ?'text': 
  'password'"
  :append-icon="show1 ?'mdi-eye':'mdi-eye-off'"   
  @click:append="show3=!show3">
</v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small class="m4u_text--text">*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="closePasswordDialog()"
          >
            Close
          </v-btn>
          <v-btn
           class="teal--text text--accent-4"
            text
            @click="updatePassword()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
          </v-container>
          <small class="m4u_text--text">*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="closeEdit()"
          >
            Close
          </v-btn>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="updateUser()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- END EDIT USER NAME/EMAIL DIALOG -->    
  </v-row>
</div> 
<!-- END OF ADD MEDIA DIALOG -->

<!-- Start of slider for content selection -->
          <div id="UserContent">

        <v-tabs
                dark
                background-color="m4u_text"
                show-arrows
              >
      <v-tabs-slider color="primary lighten-3"></v-tabs-slider>

      <v-tab
        v-for="item in items"
        :key="item"
        @click="getContent(item)"
      >
        {{ item }}
      </v-tab>
    </v-tabs>
        </div>  

<!-- START STORY CARDS --->
 
          <div v-if= "contentType === 1 || contentType===2 || contentType===3 || contentType===4 || contentType==='J'" class="justify-center"
           id="storyCard1" :width ="$vuetify.breakpoint.xs ? '70vw' : '40vw'">

          <div id="storyCard2" v-for="memory in memories" :memory="story" :key="memory.StoryID" >
            <v-layout justify-center>
          <StoryCard :story="memory" id="storyCard3_component" />
          </v-layout>
          </div>

        <!-- empty div for infinite scrolling --->
    <div v-observe-visibility="handleScrolledToBottom"></div>
        </div>    

  <!-- START BOOK CARDS --->
        <!-- <v-layout row wrap class="rowWidth"> -->
          <div v-if= "contentType === 'B'">

              <div v-for="book in books" :key="book.BookID" >
              <BookCard :book="book" />

            </div>

        </div>

        </div> 

</template>

<script>
import StoryCard from "@/components/StoryCard";
import EventService from '@/services/EventService.js'; 
import BookCard from "@/components/BookCard";

export default {
  name: 'userprofile',

  components: {
    StoryCard,
    BookCard
  },

 data() {
    return {
      tab: null,
       items: [
          'Memories', 'Recipes', 'Interviews', 'Traditions', 'Books', 'My Journals'
        ],
        contentType: 1,
        memories: [],
        recordStart: 0,
        recordLast: '',
        profileID: '',
        isUser: false,
        profileUser: [],
        story: '',
        idialog: false,
        edialog: false,
        pdialog: false,
        show1: false,
        show2: false,
        show3: false,
        file: '',
        selectedFile: null,
        message: '',
        profilesas: '',
        books: [],
        bookID: '',
        dateTC: '',
        tcYear: '',
        tcMonth: '',
        tcDay: '',
        circles: [],
        CircleID: '',
        newUser: [],
        first: '',
        last: '',
        display: '',
        TZ: '',
        tzList: [],
        ud: '',
        email: '',
        oldPassword: '',
        password1: '',
        password2: '',
        passwordChangeMsg: '',
        emailChangeMsg: false,
        nameRules: [
        value => !!value || 'Required.',
        value => (value || '').length >= 3 || 'Min 3 characters',
        value => (value || '').length <= 50 || 'Max 50 characters',
      ],
        displayNameRules: [
        value => !!value || 'Required.',
        value => (value || '').length >= 7 || 'Min 7 characters',
        value => (value || '').length <= 110 || 'Max 110 characters',
      ],
        emailRules: [
        value => !!value || 'Required.',
        value => (value || '').length <= 75 || 'Max 75 characters',
        value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      ],
        passwordRules: {
        required: value => !!value || "Required.",
        min: v => (v && v.length >= 8) || "Min 8 characters"
          }
    };
  },

 computed: {
    user(){
    return this.$store.state.user
  },
    profile(){
    return this.$store.state.user
  },
    pageLength(){
        return this.$store.state.pageLength
    },
  loginState(){
    return this.$store.state.loginState
  },
  token(){
    return this.$store.state.token
  }

  },


 created(){

 },

 mounted() {

    this.recordLast = this.pageLength;
    this.profileID = this.user.UserID
       this.getProfile(this.user.UserID);
       this.isUser = true
        this.getContent(1)
        this.getTimeZones();
    this.ud = this.user.UserDisplayName

  },


  methods: {

    async getTimeZones() {
    await EventService.getTimeZones()
      .then(
        (tzones => {
//          console.log('es returns tzones as: ', tzones)
          this.$set(this, "tzList", tzones);
        }).bind(this) )
    },

    async getProfile() {
    await EventService.getProfileUser(this.profileID)
      .then(
        (profileUser => {
          this.$set(this, "profileUser", profileUser[0]);
        }).bind(this) )
        .then(() => {
          this.$store.dispatch('setProfile', this.profileUser);
        })
        .then(async () => {
          let sas = await EventService.getSASKey(this.$store.state.profile.UserMediaLoc);
          this.$set(this, "profilesas", sas);
        })

        },

      async getUserInfo() {
      await EventService.getUserInfo(this.user.UserID)
      .then(
        (userInfo => {
          this.$set(this, "newUser", userInfo);
        }).bind(this)

      );
    },

      async updatePassword() {
      if (this.password1 === this.password2) {
      await EventService.updatePassword(this.user.UserID, this.oldPassword, this.password1)
      .then(
        (passwordConfirmation => {
          this.oldPassword = '';
          this.password1 = '';
          this.password2 = '';
          if(passwordConfirmation !== false) {
          this.passwordChangeMsg = 'Confirm your new password by '} else {
            this.passwordChangeMsg = 'Old password is incorrect'
          }
        })
       );
      } else {
        this.passwordChangeMsg = 'New passwords do not match.'
      }
    },

      async updateState() {
      await EventService.getUserInfo(this.user.UserID)
      .then(
        (userInfo => {
           this.$store.dispatch('profileUpdate', userInfo);
            this.newUser = this.user
        }).bind(this)

      );
    },

  async  getContent(item) {
    this.recordStart = 0;
    this.recordLast = '';

switch(item) {
  case 'Memories':
    this.contentType = 1
    break;
  case 'Recipes':
    this.contentType = 3
    break;
  case 'Interviews':
    this.contentType = 2
    break;
  case 'Traditions':
    this.contentType = 4
    break;
  case 'Books':
    this.contentType = 'B'
    break;
  case 'My Journals':
    this.contentType = 'J'
    break;
  default:
    this.contentType = 1
}
 
  if(this.contentType === 1 || this.contentType === 2 || this.contentType === 3 || this.contentType == 4) {
    await EventService.getProfileMemories(this.user.UserID, this.user.UserID, this.contentType, this.recordStart, this.pageLength)
      .then(
        (memories => {
            this.$set(this, "recordLast", memories.output.recordCount)
            this.$set(this, "memories", memories.recordset);
        }).bind(this)

      );
  }
  else if (this.contentType === 'J') {
    await EventService.getProfileJournals(this.user.UserID, this.user.UserID, this.recordStart, this.pageLength)
      .then(
        (memories => {
            this.$set(this, "recordLast", memories.output.recordCount)
            this.$set(this, "memories", memories.recordset);
        }).bind(this)

      )
  }
  else if (this.contentType === 'B') {
    await this.getProfileBookList();
  }
    },

  async  getMoreContent() {
 
  if(this.contentType !== 'J' && (this.recordStart < this.recordLast || !this.recordLast) ) {
    this.recordStart = this.recordStart + this.pageLength
    await EventService.getProfileMemories(this.user.UserID, this.profile.UserID, this.contentType, this.recordStart, this.pageLength)
      .then(
        (memories => {
            this.memories.push(...memories.recordset)
        }).bind(this)

      );
  }
  else if (this.contentType === 'B') {
    await this.getProfileBookList();
  }
    },
    async getProfileBookList() {
      await EventService.getProfileBookList(this.user.UserID, this.profile.UserID)
      .then(
        (books => {
          this.$set(this, "books", books);
        }).bind(this)

      );
    },

    handleScrolledToBottom(isVisible){

        if(!isVisible){
            return
        } else 
        {
        this.getMoreContent(this.contentType)
    }},

  async handleFileUpload(){
    this.file = this.$refs.file.files[0];
      this.idialog = false
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('userID', this.user.UserID);
      formData.append('token', this.$store.state.token)

      await (EventService.addNewProfileBlob(formData))
      .then((profilesas) => {
            this.selectedFile = null;
      })
      .then((profilesas) => {
        this.profilesas = profilesas;
        this.getProfile();
        this.$nextTick()
      })
  },

    async cancelFileUpload() {
        this.file = ''
        this.idialog = false

    },

    async closeEdit() {
        this.$refs.eform.reset();
         this.edialog = false;
    },

    async closePasswordDialog () {
      this.pdialog = false;
      this.passwordChangeMsg = ''
    },

    async updateUser() {
      this.edialog = false;
      var changeEmail = false;
      if (this.newUser.UserEmail !== this.user.UserEmail) {
        changeEmail = true
      } else {
        changeEmail = false}
      await (EventService.updateUser(this.newUser.UserID, this.newUser.UserFirst, this.newUser.UserLast, this.newUser.UserDisplayName, this.newUser.UserEmail, changeEmail))
      if(this.user.UserEmail !== this.newUser.UserEmail) {
        this.emailChangeMsg =  true;
      }
      this.updateState();
    },

  }


}
</script>
<style lang="scss" scoped>

.photoBtn {
  margin-top: 1em;
  margin-bottom: 1em;
}
.containerGrid {
  margin-top: 2em;
  display:grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-auto-rows: 300px;
  grid-gap: .5em;
}

.story {
  min-height: 100%;
  background-color: white;
      margin-top: 2em;
    margin-left: 2em;

  margin-bottom: 1rem;
  margin-right: 5px;

  .storyContainer {

    width: 100%;

  }

  .storySelector {
    justify-content: center;
    margin-bottom: 5px;
    margin-top: 5px;
  }


.rowWidth {
  width: 90%;
  margin-top: 10px;
  margin-right: 20px;
}
  .storyCardWrapper {
    max-height: 85%;

  }

}


</style>